import { MediaV2, MIME_TYPES_ICONS } from '../../../api/_type';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback } from 'react';

import styles from './MediaItem.module.css';
import { getFileIcon } from '../../../utils/utils';

interface MediaItemProps {
    media: MediaV2;
    onClick: (media: MediaV2) => void;
    thumbnail?: boolean;
}

export default function MediaItem({media, onClick, thumbnail}: MediaItemProps) {
   return <>
            {media.type.includes("image") ? (
              <div
                onClick={() => onClick(media)}
                className={styles.mediaImage}
                style={{ backgroundImage: "url('" + (thumbnail ? media.uri_thumbnail : media.uri) + "')" }}
              />
            ) : media.type.includes("video") ? (
              <div onClick={() => onClick(media)} className={styles.mediaImage}>
                <div className={styles.videoIconContainer}>
                  <video style={{ width: "100%" }} controls>
                    <source src={media.uri} />
                  </video>
                </div>
              </div>
            ) :  (
              <div
                onClick={() => onClick(media)}
                className={styles.mediaImage}
                style={{ backgroundImage: "url('" + media.uri + "')", display: "flex", justifyContent: "center", alignItems: "center" }}
              ><FontAwesomeIcon icon={getFileIcon(media)} fontSize={"8rem"} /></div>
            ) }
</>;
}